import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from 'react-paginate';
import Header from "../Header";
import Footer from "../Footer";
import Sidebar from "../Sidebar";
import CampaignRow from "./CampaignRow";
import BlockLoader from "../BlockLoader";
import { CAMPAIGN_CREATE_LINK } from "../../constants/constants";
import client from "../../api";
import { notifyError, exportCampaignToCSV, notifySuccess } from "../../helper";
import { confirmAlert } from "react-confirm-alert"; // Import the library
import FilterLabel from "./FilterLabel";
import "react-confirm-alert/src/react-confirm-alert.css";

const AllCampaigns = () => {
    const api = client();
    const [pageLoader, setPageLoader] = useState(true);
    const [mailAccounts,setMailAccounts] = useState();
    const [actionsDisplay,setActionsDisplay] = useState(false);
    const [count, setCount] = useState(false);
    const [campaignList,setCampaignList] = useState();
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [assignedTo, setAssignedTo] = useState('');
    const [campaignName, setCampaignName] = useState('');
    const [offset, setOffset] = useState(0); // For pagination
    const [forcePage, setForcePage] = useState(0);
    const [limit] = useState(100); // Number of campaigns per request
    const [totalCount, setTotalCount] = useState(0); // Total campaigns available
    const [appliedLabels, setAppliedLabels] = useState([]);
    const [unLabeledState, setUnLabeledState] = useState(false);
    const [allLabels, setAllLabels] = useState([]);
    const [currentLabels,setCurrentLabels] = useState([]);
    const [refreshList, setRefreshList] = useState(false);
    const [refreshFilters,setRefreshFilters] = useState(false);

    const addCheckedStatus = (data) => {
        const updatedData = data.map((v,i)=>({...v,isChecked:false}));
        setCampaignList(updatedData);
    }
    
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setIsAllChecked(isChecked);
        const updatedItems = campaignList.map((v,i)=>({...v,isChecked:isChecked}));
        setCampaignList(updatedItems);
        setActionsDisplay(isChecked);
        setCount(updatedItems.filter(item => item.isChecked).length);
        collectAppliedLabels(updatedItems);
    }

    const handleCheckboxChange = (id) => {
        const updatedItems = campaignList.map(item =>
            item._id === id ? { ...item, isChecked: !item.isChecked } : item
          );
          setIsAllChecked(updatedItems.every(item => item.isChecked));
          setActionsDisplay(updatedItems.some(item => item.isChecked));
          setCampaignList(updatedItems);
          setCount(updatedItems.filter(item => item.isChecked).length);
          collectAppliedLabels(updatedItems);
    }

    // Using this function to delete the one or more selected campaigns
    const deleteSelectedCampaigns = async () => {
        const selectedCampaignIds = campaignList.filter(item => item.isChecked).map(item => item._id);
        if(!selectedCampaignIds.length){
            notifyError('Please select at least 1 campaign to delete');
        } else {
            try{
                const response = await api.post('/v1/campaign/status/update',{
                    campaigns_id:selectedCampaignIds,
                    status:"deleted"
                });
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Selected campaigns deleted');
                    window.location.reload();
                }
            } catch(error) {
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to delete campaign(s). Please try again'); 
            }   
        }        
    }
    const collectAppliedLabels = (datalist) => {
        const data = datalist.filter(row=>row.isChecked);
        // Collect all labels from the array
        const allLabels = data.flatMap(item => item.labels);
        // Filter unique labels by their label_id and label_name
        const uniqueLabels = allLabels.reduce((acc, currLabel) => {
            const exists = acc.some(label => label.label_id === currLabel.label_id);
            if (!exists) {
                acc.push(currLabel);
            }
            return acc;
        }, []);
        setCurrentLabels(uniqueLabels);              
    }
    const bindLabelInCampaigns = async (e) => {
        try{
            if(e.target.value === ''){
                notifyError('Please select a Label');
            } else {
                setPageLoader(true);
                const selectedCampaignIds = campaignList.filter(item => item.isChecked).map(item => item._id);
                const payload = {
                    campaigns_id: selectedCampaignIds,
                    label_id: e.target.value
                }
                const response = await api.post("/v1/campaign/label/add",payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Label is successfully added in the selected campaign(s).');

                    const updatedItems = campaignList.map(item =>({ ...item, isChecked: false }));
                    setIsAllChecked(updatedItems.every(item => item.isChecked));
                    setActionsDisplay(updatedItems.some(item => item.isChecked));
                    setCampaignList(updatedItems);
                    setCount(updatedItems.filter(item => item.isChecked).length);
                    setRefreshList(!refreshList);
                }
            }
        } catch(error){
            console.log("error.message",error);
            setPageLoader(false);
            if(error.status === 400){
                notifyError("Bad Request. Unable to add Label in campaign(s). Please try again");
            }
        } finally{
            setPageLoader(false);
        }
    }

    const removeCampaignLabel = async (e) => {
        try{
            if(e.target.value === ''){
                notifyError('Please select a Label');
            } else {
                setPageLoader(true);
                const selectedCampaignIds = campaignList.filter(item => item.isChecked).map(item => item._id);
                const payload = {
                    campaigns_id: selectedCampaignIds,
                    label_id: e.target.value
                }
                const response = await api.post("/v1/campaign/label/delete",payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Label is successfully removed from the selected campaign(s).');

                    const updatedItems = campaignList.map(item =>({ ...item, isChecked: false }));
                    setIsAllChecked(updatedItems.every(item => item.isChecked));
                    setActionsDisplay(updatedItems.some(item => item.isChecked));
                    setCampaignList(updatedItems);
                    setCount(updatedItems.filter(item => item.isChecked).length);
                    setRefreshList(!refreshList);
                    collectAppliedLabels(updatedItems);
                }
            }
        } catch(error){
            console.log("error.message",error);
            setPageLoader(false);
            if(error.status === 400){
                notifyError("Bad Request. Unable to remove Label from the selected campaign(s). Please try again");
            }
        } finally{
            setPageLoader(false);
        }
    }

    const handleDownloadCSV = () => {
        exportCampaignToCSV(campaignList.filter(item => item.isChecked));
    }
    
    // Function to handle the search
    const handleSearchQuery = (event) => {
        if(event.target.name === 'teammate'){
            setAssignedTo(event.target.value);
        }
        if(event.target.name === 'record-search'){
            setCampaignName(event.target.value);
        }
        setOffset(0); // Reset offset on filter change
    }

    // Function to handle the page change event
    const onPageChange = async (data) => {
        setForcePage(data.selected)
        const newOffset = data.selected * limit
        setOffset(newOffset);
    }

    // Get mail accounts list using API
    useEffect(()=>{
        const getMailAccounts = async () => {
            try{
                const response = await api.get('/v1/mailAccount/list');
                if(response.status === 201 || response.status === 200){                
                    setMailAccounts(response.data.data);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Mail Accounts. Please try again'); 
            }
        }

        if(mailAccounts === undefined){
            getMailAccounts();
        }
        
    });

    // Get campaign list using API
    const getCampaignList = async () => {
        setPageLoader(true);
        try{
            const response = await api.post('/v1/campaign/list', { 
                campaign_name: campaignName, 
                assigned_to: assignedTo, 
                labels_id:appliedLabels,
                unlabeled:unLabeledState,
                offset: offset, 
                limit: limit 
            });
            if(response.status === 200 || response.status === 201){
                setPageLoader(false);
                addCheckedStatus(response.data.campaigns);
                setTotalCount(response.data.total_count);

                if( offset === 0){
                    setForcePage(0);
                }
                
                
            }
        } catch(error){
            console.log('error.message',error);
            setPageLoader(false);
            if(error.status === 400){
                notifyError('Bad Request. Not able to fetch Campaign List. Please try again');
            }
        }
    }

    // Call function to get campaigns list
    // Also it re-fetch the campaigns list when offset, campaignName and assignedTo value changes
    useEffect(()=>{
        getCampaignList();
    }, [offset, campaignName, assignedTo,refreshList, appliedLabels, unLabeledState]);
    
    useEffect(()=>{
        const getAllLabels = async () => {
            try{
                const response = await api.post("/v1/label/list");
                if(response.status === 200 || response.status === 201){
                    setAllLabels(response.data.labels);
                }                
            } 
            catch (error) {
                console.log('error.message',error);
                if(error.status === 400){
                    notifyError('Bad Request. Unable to fetch Labels list. Please try again.');
                }
            } 
            finally {
                //statement
            }
        }
        getAllLabels();
    },[refreshList,refreshFilters]);

    return(<>
        <Header />
        <div className="main-page">
            <Sidebar/>
            <div className="campaign-content">
                <div className="heading">
                    <h1>Campaigns</h1>
                </div>
                <div className="search-block">
                    <div className="record-search">
                        <div className="field-wrap">
                            <label className="label-xs">Search:</label>
                            <input 
                                type="text" 
                                name="record-search" 
                                placeholder="Search" 
                                onChange={(e)=>{
                                    setCampaignName(e.target.value);
                                    handleSearchQuery(e)}
                            }/>
                        </div>
                        <div className="field-wrap">
                        <label className="label-xs">Mail Account:</label>
                            <select 
                                name="teammate" 
                                className="selectbox" 
                                value={assignedTo}
                                onChange={(e)=>{
                                    setAssignedTo(e.target.value);
                                    handleSearchQuery(e);
                                }}>
                                <option value="">Any</option>
                                {mailAccounts && mailAccounts.map((v,i)=>(<option key={i} value={v.id}>{v.name}</option>))}
                            </select>
                        </div>
                    </div>

                    <div className="button-wrap">
                        <Link to={CAMPAIGN_CREATE_LINK} className="primary-btn"><i className="bx bx-plus"></i> New Campaign</Link>
                    </div>

                </div>
                
                {actionsDisplay ? <div className="action-wrap">
                    <div className="selected-records">
                        {count} selected
                    </div>
                    <div className="action-group">
                        <button 
                            className="delete-btn" 
                            onClick={()=>{ 
                                confirmAlert({
                                    title: "Delete Campaign(s)...!",
                                    message: "Are you sure you want to delete the Campaign(s)?",
                                    buttons: [
                                        { label: "Delete", onClick: () => {deleteSelectedCampaigns()} },
                                        { label: "Cancel", onClick: () => {console.log('Delete action canceled..!')}}
                                    ]
                                })
                            }}>Delete</button>
                        <button className="export-btn" onClick={()=>{handleDownloadCSV()}}>Export</button>

                        {allLabels !== null && <select className="choose-label" onChange={(e)=>{bindLabelInCampaigns(e)}}>
                            <option value={""} >Add Label</option>
                             {allLabels != null ? allLabels.map((label,i)=>(<option key={i} value={label._id} >{label.label_name}</option>)):''}
                        </select>}

                        {currentLabels.length ? <select className="remove-label" onChange={(e)=>removeCampaignLabel(e)}>
                            <option value={""} >Remove Label</option>
                            {currentLabels.map((label,i)=>(<option key={i} value={label.label_id} >{label.label_name}</option>))}
                        </select>:''}

                    </div>
                </div>:''}
                <FilterLabel 
                    setAppliedLabels={setAppliedLabels} 
                    appliedLabels = {appliedLabels}
                    setUnLabeledState = { setUnLabeledState }
                    unLabeledState = { unLabeledState }
                    setRefreshFilters = {setRefreshFilters}
                    refreshFilters = { refreshFilters }
                    />
                <div className="record-list-wrap">
                    <div className="record-list">
                            {pageLoader ? <div className="block-loader" style={{minHeight:'550px', width:'100%',background:'#fff'}}><BlockLoader /></div> : <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <label>
                                                <input type="checkbox" id="select-all" checked={isAllChecked} onChange={(e)=>{handleSelectAll(e)}} />
                                            </label>                                                                                      
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th>Created</th>
                                        <th>Mail Account</th>
                                        <th>
                                            <div className="row-header">
                                                <div className="col-head col-rec-01">Recipients</div>
                                                <div className="col-head col-rec-02">Sent</div>
                                                <div className="col-head col-rec-03">Leads</div>
                                                <div className="col-head col-rec-04">Replies</div>
                                                <div className="col-head col-rec-05">Opens</div>
                                                <div className="col-head col-rec-06">Bounces</div>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {campaignList && campaignList.map((v,i)=>(<CampaignRow 
                                        key={i} 
                                        campaign={v} 
                                        handleCheckboxChange = {handleCheckboxChange}
                                        />))}
                                </tbody>
                            </table>}
                            { totalCount > limit && <ReactPaginate 
                                breakLabel="..." 
                                nextLabel="Next" 
                                pageRangeDisplayed={5} 
                                previousLabel="Previous"
                                pageCount={Math.max(1, Math.ceil(totalCount/limit))}
                                onPageChange={onPageChange}
                                containerClassName="pagination"
                                activeClassName="active"
                                disabledClassName="disabled"
                                forcePage={forcePage}
                            />}
                            {totalCount == 0 && <div style={{padding:"auto", margin: "100px", textAlign:"center" }}>There are no campaigns to show right now.</div>}
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        </>);
}

export default AllCampaigns;